import { render } from "./Entertainment.vue?vue&type=template&id=d81cd200&scoped=true"
import script from "./Entertainment.vue?vue&type=script&lang=js"
export * from "./Entertainment.vue?vue&type=script&lang=js"

import "./Entertainment.vue?vue&type=style&index=0&id=d81cd200&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d81cd200"]])

export default __exports__